import { render, staticRenderFns } from "./ClientPropositionInfo.vue?vue&type=template&id=7056ce6b&scoped=true&"
import script from "./ClientPropositionInfo.vue?vue&type=script&lang=js&"
export * from "./ClientPropositionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7056ce6b",
  null
  
)

export default component.exports